// 导入合并reducer的依赖
import { combineReducers } from 'redux'

// 导入 登录 模块的 reducer
import A0Layout from './layout'
import A1banner from './A1banner'
import A4news from './A4news'
import A5activity from './A5activity'
import A6exhibition from './A6exhibition'
import A7collection from './A7collection'
import C1reserveOpt from './C1reserveOpt'
import Z1user from './Z1user'
import Z2log from './Z2log'
import D1feedback from './D1feedback'
import Breserve from './Breserve'
// 合并 reducer
const rootReducer = combineReducers({
  A0Layout,
  A1banner,
  A4news,
  A5activity,
  A6exhibition,
  A7collection,
  C1reserveOpt,
  Z1user,
  Z2log,
  D1feedback,
  Breserve
})

// 默认导出
export default rootReducer
